import React from "react";

interface StatCardProps {
  label: string;
  value: string;
  sub?: string;
  icon: string;
  animationClass?: string;
}

function StatCard(props: StatCardProps) {
  const { label, value, sub, icon, animationClass = "animate-fade-in" } = props;

  return (
    <div
      className={`opacity-0-start ${animationClass} bg-bg-surface border border-border rounded-lg p-5
        flex flex-col gap-2 transition-all duration-200 cursor-default
        hover:border-accent hover:bg-bg-raised hover:-translate-y-0.5 hover:shadow-card-hover`}
    >
      <div className="flex justify-between items-center">
        <span className="text-xs font-medium font-mono text-content-muted uppercase tracking-widest">
          {label}
        </span>
        <span className="text-lg opacity-50">{icon}</span>
      </div>
      <span className="text-2xl font-bold font-sans leading-none">{value}</span>
      {sub ? <span className="text-xs font-mono text-accent">{sub}</span> : null}
    </div>
  );
}

export default StatCard;